// @flow

import React, { Component } from 'react';
import styles from './StickySerpElement.less';
import { connect } from 'react-redux';
import { get, isNaN } from 'lodash';

import Sticky from 'react-sticky-el';

const getPosition = (selector: string, bottom: boolean = false): number => {
  const htmlELement = document.querySelector(selector);
  const coordinates = htmlELement && htmlELement.getBoundingClientRect();

  const positionAttribute = bottom ? 'bottom' : 'top';
  return get(coordinates, positionAttribute);
};

type Props = {
  children: any,
  activeRefinement?: string,
  target: string,
  isBelowAnchor?: boolean,
  topOffset?: number
};

type State = {|
  anchorOffset?: number
|};

const mapStateToProps = ({ search }) => ({
  activeRefinement: search.activeRefinement
});

class StickySerpElement extends Component<Props, State> {
  state = {
    anchorOffset: 0
  };

  componentDidMount() {
    this.setStickyPosition();
  }

  componentWillUpdate(nextProps) {
    if (this.props.activeRefinement !== nextProps.activeRefinement) {
      this.setStickyPosition();
    }
  }

  setStickyPosition = () => {
    const { target, isBelowAnchor } = this.props;
    const transitionDuration = 600; // See ContentSpacer.less component

    setTimeout(() => {
      const stickyPosition = getPosition(`#${target}`);
      const anchorPosition = getPosition(`[name=${target}]`, isBelowAnchor);

      const anchorOffset = anchorPosition - stickyPosition;
      this.setState({ anchorOffset });
    }, transitionDuration + 1);
  };

  render() {
    const { children, target, topOffset = 0 } = this.props;
    const { anchorOffset } = this.state;

    // Do not render sticky element if anchor does not exist
    if (isNaN(anchorOffset)) {
      return null;
    }

    return (
      <div id={target}>
        <Sticky
          stickyClassName={styles.whenSticky}
          topOffset={anchorOffset + topOffset}
        >
          <div className={styles.stickyElementWrapper}>{children}</div>
        </Sticky>
      </div>
    );
  }
}

export default connect(mapStateToProps)(StickySerpElement);
